import { useEffect } from "react";
import { useSelector } from "react-redux";
import { matchPath, useLocation, useHistory } from "react-router-dom";
import get from "lodash/get";

import { getIsAnonymous } from "../../store/modules/session/selectors";

const REFERRER = "useRedirectAnonymous";

interface LocationState {
  prevLocation?: string;
  referrer?: string;
}

export const useSessionRedirect = () => {
  const isAnonymous = useSelector(getIsAnonymous);
  const { pathname, state } = useLocation<LocationState | undefined>();
  const { replace } = useHistory();
  /* redirect to sign-in page */
  useEffect(() => {
    if (isAnonymous && !matchPath(pathname, "/settings")) {
      replace("/settings/sign-in", { prevLocation: pathname, referrer: REFERRER });
    }
  }, [pathname, isAnonymous, replace]);
  /* redirect to prev location if prevLocation set from useRedirectAnonymous */
  useEffect(() => {
    const prevLocation = get(state, "prevLocation");
    const referrer = get(state, "referrer");

    if (!isAnonymous && prevLocation && referrer === REFERRER) {
      replace(prevLocation);
    }
  }, [state, isAnonymous, replace]);
};
